enum UserStatus {
  Active = 'active',
  Inactive = 'inactive',
  Unconfirmed = 'unconfirmed',
}

export default UserStatus
